// Shared Space desktop banner render size is 1070x222.
export const BANNER_TARGET_RATIO = 1070 / 222;
export const BANNER_MIN_RATIO = 4.6;
export const BANNER_MAX_RATIO = 5.0;

export const isBannerRatioAccepted = (ratio: number): boolean =>
  ratio >= BANNER_MIN_RATIO && ratio <= BANNER_MAX_RATIO;
